import { connect } from 'react-redux';

import { deselectAllAction, deleteSelectedVideos } from 'src/actions';
import {
  selectDarkMode,
  selectSelectedVideos,
} from 'src/common/state/me/me-selectors';
import { dashboardAssignLabelsActions } from 'src/dashboard/state/assign-labels/assign-labels-actions';
import { dashboardCollectionActions } from 'src/dashboard/state/collection/collection-actions';
import { selectCreateCollectionIsLoading } from 'src/dashboard/state/collection/collection-selectors';
import type { RootState } from 'src/reducers/root';
import { shouldExposeCollections } from 'src/utils/selectors/should-expose-collections';
import { shouldRenderSidebar } from 'src/utils/selectors/should-render-sidebar';

import { VideoListHeaderComponent } from './video-list-header-component';

const mapStateToProps = (state: RootState) => ({
  createCollectionIsLoading: selectCreateCollectionIsLoading(state),
  isDarkModeEnabled: selectDarkMode(state),
  selectedVideos: selectSelectedVideos(state),
  shouldExposeCollections: shouldExposeCollections(state),
  withSidebar: shouldRenderSidebar(state),
});

const mapDispatchToProps = {
  handleBulkEditLabels: (shortcodes: string[]) =>
    dashboardAssignLabelsActions.actionsBar.editLabelsButton.clicked({
      shortcodes,
    }),
  handleCreateCollection:
    dashboardCollectionActions.videoListHeader.shareButton.clicked,
  handleDeselectAll: deselectAllAction,
  handleDeleteSelectedVideos: deleteSelectedVideos,
};

export const VideoListHeader = connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoListHeaderComponent);
